import type { SVGProps } from 'react'
const SvgReports = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.0625V12.6042H14V14.0625H0ZM0.7 11.875V6.77083H2.8V11.875H0.7ZM4.2 11.875V3.125H6.3V11.875H4.2ZM7.7 11.875V5.3125H9.8V11.875H7.7ZM11.2 11.875V0.9375H13.3V11.875H11.2Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgReports
